import React from "react";
import PropTypes from "prop-types";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
import RadioGroup from "@mui/material/RadioGroup";
// Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import RadioButton from "../radio-button/RadioButton";
import InputLabel from "../input-label/InputLabel";
import { Grid } from "@mui/material";
const useStyles = makeStyles(() => ({
  radioLabel: {
    marginTop: "12px!important",
    marginRight: "63px !important"
  }
}));
const RadioGroups = ({
  onClick,
  disabled,
  value,
  label,
  options,
  isMandatory
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(InputLabel, {
    label: t(label),
    id: "radio-group-title",
    required: isMandatory
  }), /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    onChange: (event, value) => onClick(value),
    value: value
  }, options.map((option, index) => {
    var _t;
    return /*#__PURE__*/React.createElement(RadioButton, {
      key: index,
      disabled: disabled,
      value: index,
      label: (_t = t(option.label)) !== null && _t !== void 0 ? _t : t("Yes"),
      componentsProps: {
        typography: {
          variant: "body2",
          color: theme => theme.palette.info.contrastText,
          checked: classes.checked
        }
      },
      classes: {
        root: classes.radioLabel
      },
      id: `${option.value}Radio`
    });
  })));
};
RadioGroups.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.number,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array,
  isMandatory: PropTypes.bool
};
export default RadioGroups;